import * as PIXI from "pixi.js";
import Layers from "../../layers/Layers";
import { Coord } from "../../types/Interface";
import degreeToRadian from "../../utils/degreeToRadian";


export default class AngleValue extends PIXI.Text {
  private Layers = Layers.getInstance();
  constructor(coord: Coord, color: number) {
    super();
    this.text = "60°";
    this.style.fill = color;
    this.style.fontSize = 34;
    this.style.fontWeight = "800";
    this.anchor.set(.5);
    this.setAngleValue(coord, 0, 0, 38);
    this.addToLayer();
  }
  private addToLayer = () => this.Layers.Top.addChild(this);
  setValue = (value: number | string) => this.text = `${value}°`;

  setAngleValue(cCoord: Coord, initialAngle: number, degree: number, radian) {
    const angle = initialAngle + degreeToRadian(degree / 2);

    const coord = {
      x: Math.cos(angle) * radian * 1.7 + cCoord.x,
      y: Math.sin(angle) * radian * 1.7 + cCoord.y
    }

    this.setValue(degree);
    this.style.fontSize = radian
    this.x = coord.x;
    this.y = coord.y;
  }
}